"use client";
import { BINDING_CONFIG } from "@/utils/constants";
import Script from "next/script";
import React from "react";

const CdpSdk = ({
  bindedDomain,
}: {
  bindedDomain: keyof typeof BINDING_CONFIG;
}) => {
  const scriptSrc = BINDING_CONFIG[bindedDomain].CDP_URL;
  if (!scriptSrc) {
    return null;
  }

  return (
    <Script
      id="tru-web-sdk-cdn-js"
      src={scriptSrc}
      strategy="afterInteractive"
    />
  );
};

export default CdpSdk;
